
import { call, put, takeEvery } from 'redux-saga/effects'
import FileSaver from 'file-saver';
import iconv from 'iconv-lite';

import {
    clearActionType,
    createActionTypes,
    checkOperationResult,
    setOperationError,
    setOperationStart
} from '../common/client/sagas/common';

import getPromiseCallback from '../common/client/utils/getPromiseCallback';

export const EXPORT_DATA_OPERATION_ACTION_TYPE = createActionTypes('exportData/OPERATION');
export const EXPORT_DATA_CLUSTERS_CSV_ACTION_TYPE = 'exportData/CLUSTERS_CSV';
export const EXPORT_DATA_CLUSTERS_GEOJSON_ACTION_TYPE = 'exportData/CLUSTERS_GEOJSON';
export const EXPORT_DATA_PARC_CSV_ACTION_TYPE = 'exportData/PARC_CSV';
export const EXPORT_DATA_PARC_GEOJSON_ACTION_TYPE = 'exportData/PARC_GEOJSON';
export const EXPORT_DATA_PARC_CATEGORY_JSON_ACTION_TYPE = 'exportData/PARC_CATEGORY_JSON';

export default function getActions(dispatch) {
    return {
        exportClustersCsv: (token, projectId, categoryName) => dispatch({
            type: EXPORT_DATA_CLUSTERS_CSV_ACTION_TYPE, operation: 'CLUSTERS_CSV',
            token, projectId, categoryName
        }),
        exportClustersGeoJson: (token, projectId, categoryName) => dispatch({
            type: EXPORT_DATA_CLUSTERS_GEOJSON_ACTION_TYPE, operation: 'CLUSTERS_GEOJSON',
            token, projectId, categoryName
        }),
        exportParcCsv: (token, projectId, categoryName, onlySelected) => dispatch({
            type: EXPORT_DATA_PARC_CSV_ACTION_TYPE, operation: 'PARC_CSV',
            token, projectId, categoryName, onlySelected
        }),
        exportParcGeoJson: (token, projectId, categoryName) => dispatch({
            type: EXPORT_DATA_PARC_GEOJSON_ACTION_TYPE, operation: 'PARC_GEOJSON',
            token, projectId, categoryName
        }),
        exportParcCategoryJson: (token, projectId, categoryName) => dispatch({
            type: EXPORT_DATA_PARC_CATEGORY_JSON_ACTION_TYPE, operation: 'PARC_CATEGORY_JSON',
            token, projectId, categoryName
        })
    };
}

function exportDataExec(serverApi, action) {
    const {type, ...params} = action;
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'exportDataExec',
            token: action.token,
            body: {
                params: params
            },
            callback: getPromiseCallback(
                resolve, reject, {
                    responseSelector: ''
                }
            )
        });
    });
}

function saveData(content, fileName, mimeType, encoding) {
    if (encoding) {
        content = iconv.encode(content, encoding);
        mimeType = `${mimeType}; charset=${encoding}`;
    }
    let blob = new Blob([content], {type: mimeType});
    FileSaver.saveAs(blob, fileName);
}

function* workExportDataOperation(options, func, title, fileName, mimeType, encoding, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: title});
        yield put({type: EXPORT_DATA_OPERATION_ACTION_TYPE.DEFAULT});
        const data = yield call(func, options.serverApi, action);
        yield put({type: EXPORT_DATA_OPERATION_ACTION_TYPE.SUCCESS, data});
        yield call(checkOperationResult, data.result, {title: title});
        yield call(saveData, data.result.content, fileName, mimeType, encoding);
    } catch (error) {
        yield call(setOperationError, error, EXPORT_DATA_OPERATION_ACTION_TYPE);
    }
}

export function* watchExportDataClustersCsv(options) {
    yield takeEvery(
        EXPORT_DATA_CLUSTERS_CSV_ACTION_TYPE, workExportDataOperation, options,
        exportDataExec, 'Exportování souvislosti parcel do CSV', 'cluster_parc.csv',
        'text/csv', 'windows1250'
    );
}

export function* watchExportDataClustersGeoJson(options) {
    yield takeEvery(
        EXPORT_DATA_CLUSTERS_GEOJSON_ACTION_TYPE, workExportDataOperation, options,
        exportDataExec, 'Exportování souvislosti parcel do GeoJSON', 'cluster_parc.geojson',
        'application/geo+json', 'utf8'
    );
}

export function* watchExportDataParcCsv(options) {
    yield takeEvery(
        EXPORT_DATA_PARC_CSV_ACTION_TYPE, workExportDataOperation, options,
        exportDataExec, 'Exportování parcel do CSV', 'parc.csv',
        'text/csv', 'windows1250'
    );
}

export function* watchExportDataParcGeoJson(options) {
    yield takeEvery(
        EXPORT_DATA_PARC_GEOJSON_ACTION_TYPE, workExportDataOperation, options,
        exportDataExec, 'Exportování parcel do GeoJSON', 'parc.geojson',
        'application/geo+json', 'utf8'
    );
}

export function* watchExportDataParcCategoryJson(options) {
    yield takeEvery(
        EXPORT_DATA_PARC_CATEGORY_JSON_ACTION_TYPE, workExportDataOperation, options,
        exportDataExec, 'Exportování kategorie parcel', 'category.json',
        'application/json', 'utf8'
    );
}
